import { render } from "./ViewsQuiz.vue?vue&type=template&id=362481b6"
import script from "./ViewsQuiz.vue?vue&type=script&lang=js"
export * from "./ViewsQuiz.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__